<template>
    <b-field class="mb-4" label="Corporate Ghost Cards">
        <div class="select-style-container table-layout">
            <!-- Table Headers -->
            <div class="table-row table-header">
                <div class="cell">Brand</div>
                <div class="cell">Last 4</div>
                <div class="cell">Applicable Airlines</div>
                <div class="cell">Applicable Hotel Chains</div>
            </div>

            <!-- Show -- None -->
            <div class="select-style-option full-width p-3 has-text-centered" :class="{ 'is-selected': value.length === 0 }"
                @click="clearSelection">
               -- None Selected --
            </div>

            <!-- Options -->
            <div v-for="(option, index) in cardOptions" :key="option.id" class="select-style-option table-row"
                :class="[{ 'is-selected': isChecked(option) }, { 'last-option': index === cardOptions.length - 1 }]"
                @click="toggleSelection(option)">
                <div class="cell">{{ option.brand }}</div>
                <div class="cell">{{ option.last4 }}</div>
                <div class="cell">
                    <span v-if="option.appliedToAirVendorName && option.appliedToAirVendorName.length">
                        {{ arrayToCommaString(option.appliedToAirVendorName) }}
                    </span>
                    <span v-else-if="option.appliedToAllAir">ALL</span>
                    <span v-else>&mdash;</span>
                </div>

                <div class="cell">
                    <span v-if="option.appliedToHotelVendorName && option.appliedToHotelVendorName.length">
                        {{ arrayToCommaString(option.appliedToHotelVendorName) }}
                    </span>
                    <span v-else-if="option.appliedToAllHotel">ALL</span>
                    <span v-else>&mdash;</span>
                </div>
            </div>
        </div>

    </b-field>
</template>

<script>
export default {
    props: {
        cardOptions: {
            type: Array,
            required: true,
        },
        value: {
            // v-model binding
            type: Array,
            required: true,
        },
    },
    methods: {
        isChecked(option) {
            return this.value.some(sel => sel.id === option.id);
        },
        clearSelection() {
            this.$emit('input', []);
        },
        toggleSelection(option) {
            let updated;
            if (this.isChecked(option)) {
                updated = this.value.filter(sel => sel.id !== option.id);
            } else {
                updated = [...this.value, option];
            }
            this.$emit("input", updated);
        },
        arrayToCommaString(array) {
            if (Array.isArray(array) && array.length) {
                return array.join(',');
            }
            return '';
        }

    },
};
</script>

<style scoped>
.select-style-container {
    display: flex;
    flex-direction: column;
    border: 1px solid #dbdbdb;
    box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
    border-radius: 4px;
    overflow: hidden;
    /* clip radius correctly */
}

.select-style-option {
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background-color 0.2s ease;

}

.select-style-option:first-child {
    border-top: none;
    /* no double border on first */
}

.select-style-option:hover {
    background-color: #f5f5f5;
}

.select-style-option.is-selected {
    background-color: #3273dc;
    color: white;
}


/* Rounded corners for first and last options */
.first-option {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.last-option {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

/* Special styling for the none option */
.none-option {
    color: #888;
    cursor: default;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

.table-layout {
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 14px;
}

.table-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    /* Prevent text wrap */
    overflow: hidden;
    border-bottom: 1px solid #ccc;
}

.table-header {
    font-weight: 500;
    border-bottom: 1px solid #ccc;
}

.cell {
    flex: 1;
    padding: 8px 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* Prevent wrapping inside cells */
}


.full-width {
    grid-column: span 4;
}
</style>
